import { render, staticRenderFns } from "./SeckillSessionAdd.vue?vue&type=template&id=230501a4&scoped=true"
import script from "./SeckillSessionAdd.vue?vue&type=script&lang=js"
export * from "./SeckillSessionAdd.vue?vue&type=script&lang=js"
import style0 from "./SeckillSessionAdd.vue?vue&type=style&index=0&id=230501a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230501a4",
  null
  
)

export default component.exports